import React, { useEffect, useRef } from 'react';
import { ProductDemoSection } from './product-demo/ProductDemoSection';
import { SubscriptionsPlans } from './subscription/subscription-plans.component';
import TouchPoseSection from './touch-pose/TouchPoseSection';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import packageJson from '../../../package.json';

// The TouchPose product page. It was the site's home page until the landing
// reel took over `/`; the module keeps its name because the shared subscription
// components other product pages import still live alongside it.
export const TouchPosePageContainer = () => {
  const { t } = useTranslation();
  const currentPath = useLocation();
  const targetRef = useRef<HTMLDivElement>(null);

  const ButtonClickHandler = () => {
    if (targetRef.current === null) return;

    targetRef.current.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    setTimeout(() => {
      const scrollTo = new URLSearchParams(window.location.search).get('scrollTo');
      if (scrollTo) {
        const element = document.getElementById(scrollTo);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    }, 300);
  }, [currentPath]);

  const touchposeVersion =
    (packageJson as { touchpose?: { version?: string } }).touchpose?.version ??
    t('management.product.unknownVersion');

  return (
    <div>
      <ProductDemoSection
        onClick={ButtonClickHandler}
        touchposeVersion={touchposeVersion}
      />
      <TouchPoseSection />
      <div className="md:mt-[32px] px-[22px] md:px-[72px] max-w-[945px] lg:max-w-5xl mx-auto">
        <SubscriptionsPlans
          refScroll={targetRef}
          title="Plans"
          subtitle={t('subscription.subtitle')}
        />
      </div>
    </div>
  );
};
